import { PROGRAM_DEFAULT } from "../../constants/state"
import cloneItem from '../cloneItem';

const filterAttributesByCinema = (attributes, cinemaId = false) => {
    if(!cinemaId) {
        return attributes.global
    } else if(attributes.hasOwnProperty(cinemaId)) {
        return attributes[cinemaId]
    } else {
        return cloneItem(PROGRAM_DEFAULT.attributes.global)
    }
}

export default filterAttributesByCinema